module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point03_02_winter-b60ee2b3d9dd2b5f3a1d0da8082bdfeb.jpg";